exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-icon[data-v-c2154830] {\n  background: #43a047 !important;\n}\n", ""]);

// exports
